import React from 'react';
import logo from '../../../assets/SchoolLink-logo-web.png';

interface OtpVerificationProps {
  otp: string;
  error: string | null;
  isLoading: boolean;
  onOtpChange: (otp: string) => void;
  onSubmit: () => void;
  onCancel: () => void;
}

const OtpVerification: React.FC<OtpVerificationProps> = ({
  otp,
  error,
  isLoading,
  onOtpChange,
  onSubmit,
  onCancel
}) => {
  return (
    <div>
      <div className="text-center pb-4">
        <img style={{ width: "70%" }} src={logo} className="rounded" alt="SchoolLink Logo" />
      </div>
      
      <div className="alert alert-info" role="alert">
        <p>One time password has been sent to your email. Please enter the OTP.</p>
      </div>
      
      <div className="form-group">
        <input
          type="text"
          className="form-control"
          value={otp}
          onChange={(e) => onOtpChange(e.target.value)}
          placeholder="Enter OTP"
          disabled={isLoading}
          maxLength={6}
        />
        {error && (
          <span className="alert alert-danger" style={{ color: "#f00", fontSize: '14px' }}>
            {error}
          </span>
        )}
      </div>

      <button
        type="button"
        onClick={onCancel}
        style={{ marginTop: "7px" }}
        className="pull-left bg-gradient-theme-left border-0 btn btn-outline-danger btn-lg btn-block"
        disabled={isLoading}
      >
        Cancel
      </button>
      <button
        type="button"
        onClick={onSubmit}
        style={{ marginTop: "7px" }}
        className="pull-right bg-gradient-theme-left border-0 btn btn-primary btn-lg btn-block"
        disabled={isLoading}
      >
        {isLoading ? 'Verifying...' : 'Verify OTP'}
      </button>
    </div>
  );
};

export default OtpVerification;
